<div class="campaign-start-container">
  <ngx-app-bar
    class="w-100"
    [title]="'دریافت جایزه گنج'"
    [rightButton]="{
      icon: 'arrow-right',
      style: 'neutral-link',
      mode: 'icon-only',
      size: 'medium',
    }"
    (onRightButtonClick)="onBackHandler()"
  />

  <div class="campaign-start-content">
    <img src="wealth-assets/images/treasure-hunt-2.svg" />
    <p class="campaign-start-title">برای دریافت جایزه گنج حرکت کن!</p>
    <p class="campaign-start-description">
      {{
        state.role === 'guest' ? 'در این فرایند شما ابتدا در کارگزاری ثبت‌نام می‌شوید.' : 'تنها یک مرحله برای دریافت جایزه پیش‌رو دارید.'
      }}
    </p>
  </div>
  <div class="campaign-start-buttons">
    <ngx-button
      buttonId="CAMPAIGN_START"
      [style]="'fill'"
      [fullWidth]="true"
      [leftIcon]="{ name: 'arrow-left' }"
      (clickHandler)="toNationalId()"
    >
      حرکت
    </ngx-button>
  </div>
</div>
